module.exports = __webpack_public_path__ + "img/parking-space_640.28f95920.jpg";